import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WelcomeComponent } from './screens/welcome/welcome.component';
import { SurveyComponent } from './screens/survey/survey.component';
import { FormComponent } from './screens/form/form.component';
import { SelfieComponent } from './screens/selfie/selfie.component';
import { SelfieResultComponent } from './screens/selfie-result/selfie-result.component';
import { SummaryComponent } from './screens/summary/summary.component';
import { CameraComponent } from './screens/camera/camera.component';
import { UploadViewComponent } from './screens/upload-view/upload-view.component';


const routes: Routes = [
  {
    path: 'welcome',
    component: WelcomeComponent,
  },
  {
    path: 'survey',
    component: SurveyComponent,
  },
  {
    path: 'form',
    component: FormComponent,
  },
  {
    path: 'selfie',
    component: SelfieComponent,
  },
  {
    path: 'selfie-result',
    component: SelfieResultComponent,
  },
  {
    path: 'summary',
    component: SummaryComponent,
  },
  {
    path: 'camera',
    component: CameraComponent,
  },
  {
    path: 'upload-view',
    component: UploadViewComponent,
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
